<script setup lang="ts">
import { watch } from 'vue';
import { useRoute } from 'vue-router';
import '@/assets/styles/main.css';
const route=useRoute();
watch(()=>route.path,()=>{const legal=route.path==='/impressum'?'Impressum':route.path==='/datenschutz'?'Datenschutz':'';document.title=legal?`${legal} | Muster-Nagelstudio`:'Muster-Nagelstudio | Demo-Website';},{immediate:true});
</script>
<template><RouterView/></template>
